export const SIZE_OPTIONS = [
  { value: 'small', label: 'Small' },
  { value: 'medium', label: 'Medium' },
  { value: 'large', label: 'Large' },
  { value: 'half', label: 'Half' },
  { value: 'full', label: 'Full' },
  { value: 'quarter', label: 'Quarter' },
];

export const UNIT_OPTIONS = [
  { value: 'plate', label: 'Plate' },
  { value: 'bowl', label: 'Bowl' },
  { value: 'piece', label: 'Piece' },
  { value: 'serving', label: 'Serving' },
  { value: 'glass', label: 'Glass' },
  { value: 'cup', label: 'Cup' },
  { value: 'bottle', label: 'Bottle' },
  { value: 'ml', label: 'Milliliter (ml)' },
  { value: 'liters', label: 'Liter (L)' },
];

const DEFAULT_QUANTITY_META = {
  label: 'Quantity',
  placeholder: 'e.g., 1',
  step: 'any',
};

export const UNIT_QUANTITY_META = {
  plate: { label: 'Servings / Plates', placeholder: 'e.g., 1', step: 1 },
  bowl: { label: 'Bowls', placeholder: 'e.g., 1', step: 1 },
  serving: { label: 'Servings', placeholder: 'e.g., 1', step: 1 },
  piece: { label: 'Pieces', placeholder: 'e.g., 4', step: 1 },
  glass: { label: 'Glass Volume (ml)', placeholder: 'e.g., 250', step: 1 },
  cup: { label: 'Cup Volume (ml)', placeholder: 'e.g., 200', step: 1 },
  bottle: { label: 'Bottle Volume (ml)', placeholder: 'e.g., 750', step: 1 },
  ml: { label: 'Volume (ml)', placeholder: 'e.g., 150', step: 1 },
  liters: { label: 'Volume (liters)', placeholder: 'e.g., 0.75', step: 0.1 },
};

export const getSizeLabel = (value) => {
  const match = SIZE_OPTIONS.find((option) => option.value === value);
  return match ? match.label : 'Custom';
};

export const getUnitQuantityMeta = (unit) => UNIT_QUANTITY_META[unit] || DEFAULT_QUANTITY_META;

export const formatUnitLabel = (unit) => {
  const match = UNIT_OPTIONS.find((option) => option.value === unit);
  return match ? match.label : unit;
};
